import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CsvNumberFormatter {
    private readonly _userLocale = navigator.language || 'fr-FR';
    private readonly _numberFormatsByFractionDigits = new Map<number, Intl.NumberFormat>();

    format(value: number, options: { maximumFractionDigits: number } = { maximumFractionDigits: 2 }): string {
        return this._getNumberFormat(options.maximumFractionDigits).format(value);
    }

    private _getNumberFormat(maximumFractionDigits: number): Intl.NumberFormat {
        const cachedNumberFormat = this._numberFormatsByFractionDigits.get(maximumFractionDigits);
        if (cachedNumberFormat) {
            return cachedNumberFormat;
        }
        const numberFormat = new Intl.NumberFormat(this._userLocale, { useGrouping: false, maximumFractionDigits });
        this._numberFormatsByFractionDigits.set(maximumFractionDigits, numberFormat);
        return numberFormat;
    }
}
